import { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CHAVE_TOKEN, real } from "../../../utils/formata";
import styles from "./AmbienteTeste.module.css";

// Dani, 16/09: ambiente de teste no painel. Fala direto com a porta local do robô (mesmo
// caminho do "enviar contrato pelo robô") — nada passa pela API e nada chega ao WhatsApp.
const ROBO = "http://127.0.0.1:3456";
const CHAVE_TESTE = "he_teste_id";
const PRAZO_MS = 60000;
const ITAJAI = { lat: -26.9078, lng: -48.6619 };
const SEM_ROBO = "O robô roda no PC da Dani — abra o painel nesse PC";
const LIMITE_ARQUIVO = 5 * 1024 * 1024;

const DESTINOS = {
    grupo_documentos: "grupo Documentos",
    grupo_comprovantes: "grupo Comprovantes",
    grupo_visitas: "grupo Visitas",
    privado_dani: "seu privado",
    painel: "painel (simulado)",
};

// Dani, 16/09: ela responde NO GRUPO como na vida real — SIM / NÃO / VISITA OK no Documentos, PAGO no Comprovantes.
// O robô cita o último cartão daquele grupo registrado no teste (citar: "ultimo").
const GRUPOS = { documentos: "grupo Documentos", comprovantes: "grupo Comprovantes" };
const RESPOSTAS_GRUPO = [
    { grupo: "documentos", texto: "SIM", dica: "Aprova o cartão: a esteira segue pro agendamento da visita (manhã ou tarde) com o cliente" },
    { grupo: "documentos", texto: "NÃO", dica: "Recusa o cartão no grupo Documentos, como você faria de verdade" },
    { grupo: "documentos", texto: "VISITA OK", dica: "Visita feita: aprova a proposta e cria o contrato no painel (aqui só simulado)" },
    { grupo: "comprovantes", texto: "PAGO", dica: "Dá baixa na diária do último comprovante que o robô postou no grupo" },
];
// Cartão "Esteira e humano" mostra só o que a Dani lê — jid/telefone crus e a etapa repetida ficam de fora (cético tela#4)
const CAMPOS_ESTEIRA = [
    ["propostaId", "Proposta"], ["emprestimoId", "Contrato"], ["nome", "Nome"], ["empresa", "Empresa"],
    ["valor", "Valor"], ["plano", "Plano"], ["documento", "Documento"], ["endereco", "Endereço"], ["desde", "Desde"],
];
const AVISO_VENCIDO = "Teste vencido (3 dias) — o robô já apagou. Crie um novo.";
const AVISO_APAGADO = "Este teste já foi apagado pelo robô (limpeza de 3 dias). Crie um novo.";

async function chamarRobo(caminho, { metodo = "GET", corpo } = {}) {
    const controle = new AbortController();
    const alarme = setTimeout(() => controle.abort(), PRAZO_MS);
    try {
        // X-Help só no POST: no GET ele forçaria um preflight a cada 2 s de polling
        const r = await fetch(ROBO + caminho, {
            method: metodo,
            headers: metodo === "GET" ? undefined : { "X-Help": "1", "Content-Type": "application/json" },
            body: corpo ? JSON.stringify(corpo) : undefined,
            signal: controle.signal,
        });
        const j = await r.json().catch(() => ({}));
        if (!r.ok || !j.ok) {
            const e = new Error(j.mensagem || j.erro || `robô respondeu ${r.status}`);
            e.status = r.status;
            throw e;
        }
        return j;
    } catch (e) {
        if (e.name === "AbortError") {
            const demorou = new Error("O robô não respondeu em 60 segundos — a tela continua acompanhando pelo polling.");
            demorou.demorou = true;
            throw demorou;
        }
        if (/Failed to fetch|NetworkError|Load failed/i.test(String(e.message))) {
            const semRobo = new Error(SEM_ROBO);
            semRobo.semRobo = true;
            throw semRobo;
        }
        throw e;
    } finally {
        clearTimeout(alarme);
    }
}

function lerIdSalvo() {
    try { return localStorage.getItem(CHAVE_TESTE) || ""; } catch { return ""; }
}
function guardarId(id) {
    try { id ? localStorage.setItem(CHAVE_TESTE, id) : localStorage.removeItem(CHAVE_TESTE); } catch {}
}

// Cético painel#1 (16/09): o retrato do robô velho não trazia pushName e o polling apagava o nome que veio
// do POST /teste/nova. O retrato manda quando traz; enquanto não trouxer, fica o nome do mesmo teste.
const comPushName = (retrato) => (t) => ({ ...retrato, pushName: retrato.pushName ?? (t?.id === retrato.id ? t.pushName : undefined) });

const tempo = (q) => {
    const t = typeof q === "number" ? q : Date.parse(q);
    return Number.isFinite(t) ? t : 0;
};
const hora = (t) => (t ? new Date(t).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "");
const dataHora = (q) => { const t = tempo(q); return t ? new Date(t).toLocaleString("pt-BR") : "—"; };

function montarLinha(teste) {
    const itens = [];
    (teste?.entradas || []).forEach((e, i) => itens.push({ ...e, lado: "entrada", t: tempo(e.quando), ordem: i }));
    (teste?.saidas || []).forEach((s, i) => itens.push({ ...s, lado: "saida", t: tempo(s.quando), ordem: i }));
    // mesmo instante: a mensagem do cliente vem antes da resposta
    return itens.sort((a, b) => a.t - b.t || (a.lado === b.lado ? a.ordem - b.ordem : a.lado === "entrada" ? -1 : 1));
}

function rotuloArquivo(mimetype = "") {
    if (mimetype.startsWith("image/")) return "Foto";
    if (mimetype.startsWith("audio/")) return "Áudio";
    if (mimetype === "application/pdf") return "PDF";
    return "Documento";
}

function formatarValor(v) {
    if (v === null || v === undefined || v === "") return "—";
    if (typeof v === "boolean") return v ? "sim" : "não";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
}

function formatarEsteira(k, v) {
    if (k === "desde") return dataHora(v);
    if (k === "valor" && v !== null && v !== "" && Number.isFinite(Number(v))) return real(v);
    return formatarValor(v);
}

function Miudos({ extra }) {
    if (!extra) return null;
    const partes = [];
    if (extra.provedor) partes.push(`provedor: ${extra.provedor}`);
    if (Array.isArray(extra.faltas) && extra.faltas.length) partes.push(`faltas: ${extra.faltas.join(", ")}`);
    if (extra.corrigido) partes.push(`corrigido: ${extra.corrigido}`);
    if (extra.idMensagem) partes.push(`id: ${extra.idMensagem}`);
    if (!partes.length) return null;
    return <div className={styles.miudos}>{partes.map((p) => <span key={p}>{p}</span>)}</div>;
}

function ItemLinha({ it }) {
    if (it.lado === "entrada") {
        const noGrupo = it.tipo === "grupo";
        const dani = it.tipo === "dani" || noGrupo;
        let etiqueta = null;
        let corpo = it.texto;
        if (noGrupo) etiqueta = `Você (Dani, no ${GRUPOS[it.grupo] || `grupo ${it.grupo || "?"}`})`;
        else if (dani) etiqueta = "Você (Dani, pelo WhatsApp)";
        else if (it.tipo === "audio") etiqueta = "Áudio (transcrição)";
        else if (it.tipo === "arquivo") etiqueta = `${rotuloArquivo(it.mimetype)}: ${it.nomeArquivo || "arquivo"}`;
        else if (it.tipo === "localizacao") { etiqueta = "Localização"; corpo = it.texto || `${ITAJAI.lat}, ${ITAJAI.lng}`; }
        return (
            <div className={`${styles.linha} ${dani ? styles.linha_esq : styles.linha_dir}`}>
                <div className={`${styles.balao} ${dani ? styles.balao_dani : styles.balao_cliente}`}>
                    {etiqueta && <span className={styles.etiqueta}>{etiqueta}</span>}
                    {corpo && <div className={styles.texto}>{corpo}</div>}
                    <span className={styles.hora}>{hora(it.t)}</span>
                </div>
            </div>
        );
    }

    if (it.tipo === "cliente") {
        return (
            <div className={`${styles.linha} ${styles.linha_esq}`}>
                <div className={`${styles.balao} ${styles.balao_robo}`}>
                    <div className={styles.texto}>{it.texto}</div>
                    {it.extra?.arquivo && <span className={styles.anexo}>Anexo: {it.extra.arquivo}</span>}
                    <Miudos extra={it.extra} />
                    <span className={styles.hora}>{hora(it.t)}</span>
                </div>
            </div>
        );
    }

    // eventos internos: grupos, privado da Dani, painel simulado, silêncio
    const silencio = it.tipo === "silencio";
    const titulo = silencio
        ? `silêncio: ${it.texto || it.destino || "sem motivo informado"}`
        : it.tipo === "painel"
            ? `→ painel (simulado): ${it.extra?.metodo || "POST"} ${it.extra?.rota || ""}`.trim()
            : `→ ${DESTINOS[it.tipo] || it.destino || it.tipo}`;
    return (
        <div className={styles.linha_centro}>
            <div className={`${styles.cartao} ${silencio ? styles.cartao_silencio : ""}`}>
                <div className={styles.cartao_titulo}>
                    <span>{titulo}</span>
                    <span className={styles.hora_cartao}>{hora(it.t)}</span>
                </div>
                {!silencio && it.texto && <div className={styles.cartao_texto}>{it.texto}</div>}
                {it.extra?.arquivo && <div className={styles.cartao_texto}>Anexo: {it.extra.arquivo}</div>}
                {it.tipo === "painel" && it.extra?.corpo &&
                    <details className={styles.detalhe}>
                        <summary>corpo enviado</summary>
                        <pre className={styles.pre_mini}>{it.extra.corpo}</pre>
                    </details>
                }
                <Miudos extra={it.extra} />
            </div>
        </div>
    );
}

export default function AmbienteTeste() {
    const [personas, setPersonas] = useState([]);
    const [persona, setPersona] = useState("");
    const [pushName, setPushName] = useState("");
    const [teste, setTeste] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [semRobo, setSemRobo] = useState(false);
    const [erro, setErro] = useState("");
    const [texto, setTexto] = useState("");
    const [arquivo, setArquivo] = useState(null);
    const [legenda, setLegenda] = useState("");
    const [emVoo, setEmVoo] = useState(0);
    const [criando, setCriando] = useState(false);
    const [zerando, setZerando] = useState(false);
    const chatRef = useRef(null);
    const arquivoRef = useRef(null);
    const vivoRef = useRef(true);
    const navigate = useNavigate();

    // rearma no mount de propósito: o StrictMode desmonta e monta de novo em dev
    useEffect(() => {
        vivoRef.current = true;
        return () => { vivoRef.current = false; };
    }, []);

    // Cético tela#1 (16/09): a carga inicial é uma função reutilizável — o polling chama de novo
    // enquanto o robô estiver fora, e "Tentar agora" também, sem recarregar a página.
    const carregar = useCallback(async () => {
        try {
            const p = await chamarRobo("/teste/personas");
            if (!vivoRef.current) return;
            setPersonas(p.personas || []);
            setSemRobo(false);
            const id = lerIdSalvo();
            if (!id) return;
            try {
                const r = await chamarRobo(`/teste/${encodeURIComponent(id)}`);
                if (vivoRef.current) setTeste(comPushName(r.teste));
            } catch (e) {
                // 404 = teste antigo já varrido pela limpeza do robô; 410 = passou de 3 dias.
                // setTeste(null) importa no "Tentar agora" com teste aberto: o retrato velho não pode ficar na tela
                if (e.status === 404) { guardarId(null); setTeste(null); }
                else if (e.status === 410) { guardarId(null); setTeste(null); setErro(AVISO_VENCIDO); }
                else throw e;
            }
        } catch (e) {
            if (!vivoRef.current) return;
            // Cético painel#2 (16/09): só falha de rede é "robô fora". Resposta HTTP (404 do robô velho, 500)
            // é robô respondendo — pill verde, o polling de 2 s para e o aviso fica até ela fechar.
            // timeout de 60 s sem teste aberto conta como fora: senão o polling para e ninguém tenta de novo
            if (e.semRobo || e.demorou) { setSemRobo(true); return; }
            setSemRobo(false);
            setErro(e.status === 404 ? "O robô neste PC ainda não conhece o ambiente de teste — reinicie o robô com a versão nova." : e.message);
        }
    }, []);

    useEffect(() => {
        if (!localStorage.getItem(CHAVE_TOKEN)) {
            navigate("/login");
            return;
        }
        carregar().finally(() => { if (vivoRef.current) setCarregando(false); });
    }, [navigate, carregar]);

    // A resposta do robô chega com atraso (espaçamento de 12–20 s, releitura):
    // o POST devolve o que já saiu e daqui pra frente é o polling que completa.
    // Sem teste aberto e com o robô fora, o mesmo relógio refaz a carga inicial (cético tela#1).
    const testeId = teste?.id;
    useEffect(() => {
        if (!testeId && !semRobo) return;
        let vivo = true;
        let ocupado = false;
        const buscar = async () => {
            if (ocupado || document.hidden) return;
            ocupado = true;
            try {
                if (!testeId) { await carregar(); return; }
                const r = await chamarRobo(`/teste/${encodeURIComponent(testeId)}`);
                if (vivo) { setTeste(comPushName(r.teste)); setSemRobo(false); }
            } catch (e) {
                if (!vivo) return;
                if (e.semRobo) setSemRobo(true);
                else if (e.status === 404 || e.status === 410) {
                    guardarId(null);
                    setTeste(null);
                    setErro(e.status === 410 ? AVISO_VENCIDO : AVISO_APAGADO);
                }
            } finally {
                ocupado = false;
            }
        };
        const t = setInterval(buscar, 2000);
        return () => { vivo = false; clearInterval(t); };
    }, [testeId, semRobo, carregar]);

    const linha = montarLinha(teste);
    useEffect(() => {
        const el = chatRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [linha.length, testeId]);

    function tratarErro(e) {
        if (e.semRobo) setSemRobo(true);
        else if (e.status === 410) { guardarId(null); setTeste(null); setErro(AVISO_VENCIDO); }
        else setErro(e.message);
    }

    async function novoTeste() {
        setCriando(true);
        setErro("");
        try {
            const nome = pushName.trim();
            const r = await chamarRobo("/teste/nova", { metodo: "POST", corpo: { ...(persona ? { persona } : {}), ...(nome ? { pushName: nome } : {}) } });
            setTeste(r.teste);
            guardarId(r.teste.id);
            setSemRobo(false);
            setTexto(""); setArquivo(null); setLegenda("");
        } catch (e) {
            tratarErro(e);
        } finally {
            setCriando(false);
        }
    }

    async function zerar() {
        if (!teste) return;
        if (!window.confirm("Zerar este teste? A conversa e o caderninho dele somem do robô.")) return;
        setZerando(true);
        setErro("");
        try {
            const r = await chamarRobo(`/teste/${encodeURIComponent(teste.id)}/zerar`, { metodo: "POST", corpo: {} });
            // 202: havia mensagem em voo — o robô termina de apagar sozinho quando ela pousar
            if (r && r.aguardando) setErro(r.mensagem || "Ainda havia uma resposta em andamento — o robô termina de apagar este teste sozinho em até 5 minutos.");
        } catch (e) {
            if (e.status !== 404 && e.status !== 410) { tratarErro(e); setZerando(false); return; }
        }
        setTeste(null);
        guardarId(null);
        setZerando(false);
    }

    // Devolve true só no sucesso: o que foi digitado/escolhido fica no campo até o robô aceitar (cético tela#3)
    async function mandar(corpo) {
        if (!teste) return false;
        setEmVoo((n) => n + 1);
        setErro("");
        try {
            const r = await chamarRobo(`/teste/${encodeURIComponent(teste.id)}/mensagem`, { metodo: "POST", corpo });
            // resposta lenta de um teste que já foi trocado não pode recolocar o retrato velho na tela
            setTeste((t) => (t && r.teste && t.id !== r.teste.id ? t : comPushName(r.teste)(t)));
            setSemRobo(false);
            return true;
        } catch (e) {
            tratarErro(e);
            return false;
        } finally {
            setEmVoo((n) => n - 1);
        }
    }

    async function enviarTexto(modo) {
        const t = texto.trim();
        if (!t || !teste || emVoo > 0) return;
        const corpo = modo === "dani" ? { texto: t, comoDani: true } : modo === "audio" ? { texto: t, viaAudio: true } : { texto: t };
        if (await mandar(corpo)) setTexto("");
    }

    function responderNoGrupo(grupo, t) {
        mandar({ grupo, texto: t, citar: "ultimo" });
    }

    function escolherArquivo(e) {
        const f = e.target.files && e.target.files[0];
        e.target.value = "";
        if (!f) return;
        if (f.size > LIMITE_ARQUIVO) { setErro("Arquivo acima de 5 MB — comprime antes de mandar."); return; }
        const leitor = new FileReader();
        leitor.onload = () => {
            const base64 = String(leitor.result).split(",")[1] || "";
            setArquivo({ nome: f.name, mimetype: f.type || "application/octet-stream", base64, tamanho: f.size });
        };
        leitor.onerror = () => setErro("Não consegui ler o arquivo.");
        leitor.readAsDataURL(f);
    }

    async function enviarArquivo() {
        if (!arquivo || emVoo > 0) return;
        const ok = await mandar({ arquivo: arquivo.base64, mimetype: arquivo.mimetype, nomeArquivo: arquivo.nome, legenda: legenda.trim() || undefined });
        if (ok) { setArquivo(null); setLegenda(""); }
    }

    const estado = teste?.estado || null;
    const dados = Object.entries(estado?.dados || {});
    const esteira = estado?.esteira && typeof estado.esteira === "object" ? estado.esteira : null;
    const etapaEsteira = esteira ? (esteira.etapa ?? esteira.fase ?? esteira.passo ?? esteira.estado ?? "na esteira") : null;
    const camposEsteira = esteira ? CAMPOS_ESTEIRA.filter(([k]) => k in esteira) : [];
    // a faixa "Responder como a Dani no grupo" só aparece pros grupos que já receberam cartão neste teste
    const gruposComCartao = ["documentos", "comprovantes"].filter((g) => (teste?.saidas || []).some((s) => s.tipo === `grupo_${g}`));
    const nomePersona = personas.find((p) => p.id === teste?.persona)?.nome || teste?.persona || "sem persona (cliente novo)";
    const descricaoPersona = personas.find((p) => p.id === persona)?.descricao || "";
    const ultimaEntrada = Math.max(0, ...(teste?.entradas || []).map((e) => tempo(e.quando)));
    const ultimaSaida = Math.max(0, ...(teste?.saidas || []).map((s) => tempo(s.quando)));
    const aguardando = !!teste && (emVoo > 0 || (ultimaEntrada > ultimaSaida && Date.now() - ultimaEntrada < 90000));
    const podeEscrever = !!teste && !semRobo && emVoo === 0;

    return (
        <div className="pagina">
            <div className="cabecalho-pagina">
                <div style={{ minWidth: 0 }}>
                    <h2 className="he-titulo">Ambiente <span className="he-dourado">de teste</span></h2>
                    <p style={{ color: "#9aa5b5", fontSize: "0.9em", margin: 0 }}>
                        Converse com o robô como se fosse um cliente. Nada sai pro WhatsApp e nada grava no painel.
                    </p>
                </div>
                <div className="he-card resumo-topo" style={{ padding: "0.8em 1em" }}>
                    <span className={styles.pulso} style={{ background: semRobo ? "#e74c3c" : "#2ecc71", boxShadow: `0 0 10px ${semRobo ? "#e74c3c" : "#2ecc71"}` }}></span>
                    <span style={{ fontWeight: 700, color: semRobo ? "#ff6b5b" : "#2ecc71", whiteSpace: "nowrap" }}>
                        {semRobo ? "Robô fora de alcance" : "Robô na porta local"}
                    </span>
                </div>
            </div>

            {semRobo &&
                <div className={styles.aviso}>
                    <i className="bi bi-plug"></i>
                    <span>{SEM_ROBO}. Enquanto esta aba estiver visível, a tela tenta de novo sozinha a cada 2 segundos.</span>
                    <button className="btn btn-sm btn-outline-he" onClick={() => carregar()} disabled={carregando}>Tentar agora</button>
                </div>
            }
            {erro &&
                <div className={`${styles.aviso} ${styles.aviso_erro}`}>
                    <i className="bi bi-exclamation-triangle"></i>
                    <span>{erro}</span>
                    <button className="btn btn-sm btn-outline-he" onClick={() => setErro("")}>Fechar</button>
                </div>
            }

            <div className={`he-card ${styles.barra}`}>
                <div className={styles.barra_persona}>
                    <label className="form-label" htmlFor="persona-teste">Persona do cliente falso</label>
                    <select id="persona-teste" className="form-select form-select-sm" value={persona} onChange={(e) => setPersona(e.target.value)} disabled={criando}>
                        <option value="">Sem persona — cliente novo, caderninho vazio</option>
                        {personas.map((p) => <option key={p.id} value={p.id}>{p.nome}</option>)}
                    </select>
                    {descricaoPersona && <div className={styles.dica}>{descricaoPersona}</div>}
                </div>
                <div className={styles.barra_nome}>
                    <label className="form-label" htmlFor="nome-teste">Nome no WhatsApp (pushName)</label>
                    <input id="nome-teste" className="form-control form-control-sm" placeholder="Teste (padrão do robô)" maxLength={40}
                        value={pushName} onChange={(e) => setPushName(e.target.value)} disabled={criando} />
                </div>
                <div className={`acoes-linha ${styles.barra_botoes}`}>
                    <button className="btn btn-he" onClick={novoTeste} disabled={criando || semRobo || carregando || emVoo > 0}>
                        {criando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-plus-lg"></i> Novo teste</>}
                    </button>
                    <button className="btn btn-outline-danger" onClick={zerar} disabled={!teste || zerando || semRobo}>
                        {zerando ? <span className="spinner-border spinner-border-sm"></span> : <><i className="bi bi-eraser"></i> Zerar</>}
                    </button>
                </div>
            </div>

            {teste &&
                <div className={styles.meta}>
                    <span><strong>Telefone falso:</strong> {teste.telefone}</span>
                    <span><strong>Chave:</strong> {teste.ch}</span>
                    <span><strong>Persona:</strong> {nomePersona}</span>
                    {teste.pushName && <span><strong>Nome no WhatsApp:</strong> {teste.pushName}</span>}
                    <span><strong>Criado:</strong> {dataHora(teste.criadoEm)}</span>
                </div>
            }

            <div className={styles.grade}>
                <section className={`he-card ${styles.chat}`}>
                    <div className={styles.lista} ref={chatRef}>
                        {carregando &&
                            <div className={styles.vazio}><span className="spinner-border" style={{ color: "#d4af37" }}></span></div>
                        }
                        {!carregando && !teste &&
                            <div className={styles.vazio}>
                                <i className="bi bi-chat-square-dots" style={{ fontSize: "2.2em", color: "#d4af37" }}></i>
                                <p>Escolha uma persona (ou nenhuma) e clique em <strong className="he-dourado">Novo teste</strong>.</p>
                                <p className={styles.dica}>O robô responde neste chat exatamente como responderia no WhatsApp — com o mesmo caderninho, esteira e travas.</p>
                            </div>
                        }
                        {teste && linha.length === 0 &&
                            <div className={styles.vazio}>
                                <p>Teste pronto. Mande a primeira mensagem como cliente.</p>
                            </div>
                        }
                        {linha.map((it) => <ItemLinha key={`${it.lado}-${it.ordem}`} it={it} />)}
                        {aguardando &&
                            <div className={styles.digitando}>
                                <span className="spinner-border spinner-border-sm"></span> o robô está processando (pode levar 12–20 s)
                            </div>
                        }
                    </div>

                    <div className={styles.composer}>
                        {gruposComCartao.length > 0 &&
                            <div className={styles.faixa_grupo}>
                                <span className={styles.faixa_grupo_titulo}><i className="bi bi-people"></i> Responder como a Dani no grupo</span>
                                {gruposComCartao.map((g) => (
                                    <div key={g} className={styles.faixa_grupo_bloco}>
                                        <span className={styles.faixa_grupo_rotulo}>{GRUPOS[g]}</span>
                                        {RESPOSTAS_GRUPO.filter((r) => r.grupo === g).map((r) => (
                                            <button key={r.texto} className="btn btn-sm btn-outline-he" onClick={() => responderNoGrupo(g, r.texto)} disabled={!podeEscrever} title={r.dica}>
                                                {r.texto}
                                            </button>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        }
                        {arquivo &&
                            <div className={styles.anexo_pendente}>
                                <div className={styles.anexo_info}>
                                    <i className="bi bi-paperclip"></i>
                                    <span>{rotuloArquivo(arquivo.mimetype)}: <strong>{arquivo.nome}</strong> ({(arquivo.tamanho / 1024).toFixed(0)} KB)</span>
                                </div>
                                <input className="form-control form-control-sm" placeholder="Legenda (opcional) — o que o cliente escreveria junto"
                                    value={legenda} onChange={(e) => setLegenda(e.target.value)} disabled={emVoo > 0}
                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); enviarArquivo(); } }} />
                                <div className="acoes-linha">
                                    <button className="btn btn-sm btn-he" onClick={enviarArquivo} disabled={!podeEscrever}>
                                        <i className="bi bi-send"></i> Enviar arquivo
                                    </button>
                                    <button className="btn btn-sm btn-outline-he" onClick={() => { setArquivo(null); setLegenda(""); }}>Cancelar</button>
                                </div>
                            </div>
                        }
                        <div className={styles.composer_linha}>
                            <input
                                className="form-control"
                                placeholder={teste ? "Escreva como o cliente escreveria..." : "Crie um teste pra começar"}
                                value={texto}
                                disabled={!podeEscrever}
                                onChange={(e) => setTexto(e.target.value)}
                                onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); enviarTexto("cliente"); } }}
                            />
                            <button className="btn btn-he" onClick={() => enviarTexto("cliente")} disabled={!podeEscrever || !texto.trim()} title="Manda como cliente (Enter)">
                                <i className="bi bi-send"></i> Enviar
                            </button>
                        </div>
                        <div className={`acoes-linha ${styles.composer_extras}`}>
                            <button className="btn btn-sm btn-outline-he" onClick={() => enviarTexto("dani")} disabled={!podeEscrever || !texto.trim()} title="O texto entra como mensagem sua pelo WhatsApp (fromMe)">
                                <i className="bi bi-person-check"></i> Como Dani
                            </button>
                            <button className="btn btn-sm btn-outline-he" onClick={() => enviarTexto("audio")} disabled={!podeEscrever || !texto.trim()} title="O texto vira a transcrição de um áudio do cliente">
                                <i className="bi bi-mic"></i> Áudio
                            </button>
                            <button className="btn btn-sm btn-outline-he" onClick={() => arquivoRef.current && arquivoRef.current.click()} disabled={!podeEscrever} title="Foto ou documento como o cliente mandaria">
                                <i className="bi bi-image"></i> Foto/Documento
                            </button>
                            <button className="btn btn-sm btn-outline-he" onClick={() => mandar({ localizacao: ITAJAI })} disabled={!podeEscrever} title={`Localização fixa de Itajaí (${ITAJAI.lat}, ${ITAJAI.lng})`}>
                                <i className="bi bi-geo-alt"></i> Localização
                            </button>
                        </div>
                        <input ref={arquivoRef} type="file" hidden accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt,audio/*" onChange={escolherArquivo} />
                    </div>
                </section>

                <aside className={styles.estado}>
                    <div className="he-card">
                        <h5 className="he-titulo he-dourado"><i className="bi bi-cpu"></i> Estado do sistema</h5>
                        <pre className={styles.bloco}>{estado?.bloco || "— sem teste aberto —"}</pre>
                    </div>

                    <div className="he-card">
                        <h5 className="he-titulo he-dourado"><i className="bi bi-journal-text"></i> Caderninho</h5>
                        {dados.length === 0
                            ? <div className={styles.dica}>Vazio — o robô ainda não anotou nada.</div>
                            : <dl className={styles.caderninho}>
                                {dados.map(([k, v]) => (
                                    <div key={k} className={styles.caderninho_linha}>
                                        <dt>{k}</dt>
                                        <dd>{formatarValor(v)}</dd>
                                    </div>
                                ))}
                            </dl>
                        }
                    </div>

                    <div className="he-card">
                        <h5 className="he-titulo he-dourado"><i className="bi bi-signpost-split"></i> Esteira e humano</h5>
                        <dl className={styles.caderninho}>
                            <div className={styles.caderninho_linha}>
                                <dt>Dani assumiu</dt>
                                <dd className={estado?.humanoAssumiu ? styles.sim : ""}>{estado ? (estado.humanoAssumiu ? "sim" : "não") : "—"}</dd>
                            </div>
                            <div className={styles.caderninho_linha}>
                                <dt>Silêncio</dt>
                                <dd>{estado?.silencio || "—"}</dd>
                            </div>
                            <div className={styles.caderninho_linha}>
                                <dt>Etapa da esteira</dt>
                                <dd>{estado ? (esteira ? formatarValor(etapaEsteira) : "fora da esteira (sem contrato fechado)") : "—"}</dd>
                            </div>
                            {camposEsteira.map(([k, rotulo]) => (
                                <div key={k} className={`${styles.caderninho_linha} ${styles.caderninho_sub}`}>
                                    <dt>{rotulo}</dt>
                                    <dd>{formatarEsteira(k, esteira[k])}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>

                    <details className={`he-card ${styles.ficha}`}>
                        <summary><i className="bi bi-file-earmark-text"></i> Ficha inteira da conversa</summary>
                        <pre className={styles.bloco}>{estado?.ficha || "—"}</pre>
                    </details>

                    {estado?.sistema &&
                        <details className={`he-card ${styles.ficha}`}>
                            <summary><i className="bi bi-braces"></i> Classificação bruta (sistema)</summary>
                            <pre className={styles.bloco}>{JSON.stringify(estado.sistema, null, 2)}</pre>
                        </details>
                    }
                </aside>
            </div>
        </div>
    );
}
